import { useTheme } from 'contexts'
import React from 'react'
import { StyleSheet } from 'react-native'

import { Box } from 'widgets/Box'
import { LoadingSpinner } from 'widgets/LoadingSpinner'
import { Pressable } from 'widgets/Pressable'
import { Text } from 'widgets/Text'

interface SubmitButtonTypes {
  handleSubmit?: () => void
  title?: string
  loading?: boolean
}

export const SubmitButton = ({ handleSubmit, title, loading }: SubmitButtonTypes) => {
  const theme = useTheme()
  const styles = StyleSheet.create({
    text: {
      color: theme.colors.white,
    },
  })

  return (
    <Box>
      <Pressable onPress={handleSubmit}>
        <Box
          height={50}
          borderRadius='xs'
          backgroundColor={!loading ? 'v2primary' : 'transparent'}
          justifyContent='center'
          align='center'
        >
          {loading ? <LoadingSpinner /> : null}
          {!loading && (
            <Text style={styles.text} bold>
              {title}
            </Text>
          )}
        </Box>
      </Pressable>
    </Box>
  )
}
